/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Danish (Denmark)
export default {
  'project-actions.project-content.archive-error-title': 'Projektet kunne ikke gendannes',
  'project-actions.project-content.archive-project': 'Arkivér projekt',
  'project-actions.project-content.archive-restore-error-description':
    'Projektændringerne kunne ikke gemmes. Prøv igen senere.',
  'project-actions.project-content.copy-link': 'Kopiér link',
  'project-actions.project-content.copy-project': 'Kopiér projekt',
  'project-actions.project-content.copy-project.cancel': 'Annuller',
  'project-actions.project-content.copy-project.close-modal': 'Luk modal',
  'project-actions.project-content.copy-project.error': 'Giv dit projekt et navn, så alle ved, hvad det handler om',
  'project-actions.project-content.copy-project.failed-description':
    'Der opstod en fejl under kloning af projektet. Prøv igen senere.',
  'project-actions.project-content.copy-project.failed-description-forbidden':
    'Du har ikke tilladelse til at kopiere dette projekt.',
  'project-actions.project-content.copy-project.failed-title': 'Vi kunne ikke klone dette projekt.',
  'project-actions.project-content.copy-project.followers': 'Følgere',
  'project-actions.project-content.copy-project.include': 'Inkluder',
  'project-actions.project-content.copy-project.links': 'Links',
  'project-actions.project-content.copy-project.project-name': 'Projektnavn',
  'project-actions.project-content.copy-project.submit': 'Send',
  'project-actions.project-content.copy-project.success-description': 'Projektet er blevet klonet.',
  'project-actions.project-content.copy-project.success-link': 'Vis klonet projekt.',
  'project-actions.project-content.copy-project.success-title': 'Projektet {projectName} blev klonet.',
  'project-actions.project-content.copy-project.title': 'Kopiér projekt',
  'project-actions.project-content.follow': 'Følg',
  'project-actions.project-content.follow-confirmation-description':
    'Hver mandag morgen sender vi dig en oversigt med opdateringer for alle de projekter, du følger. Hvorfor om mandagen? <a>Læs her.</a>',
  'project-actions.project-content.follow-confirmation-title': '🙌🏼 Du følger nu dette projekt!',
  'project-actions.project-content.follow-error-title': 'Projektet kunne ikke følges',
  'project-actions.project-content.follow-unfollow-error-description':
    'Projektændringerne kunne ikke gemmes. Prøv igen senere.',
  'project-actions.project-content.restore-project': 'Gendan projekt',
  'project-actions.project-content.share': 'Del',
  'project-actions.project-content.unfollow': 'Ophør med at følge',
  'project-actions.project-content.unfollow-error-title': 'Kunne ikke stoppe med at følge projektet',
};
